<ul>
  <li *ngFor="let user of users">
    {{ user.name }}
  </li>
</ul>
